module.exports = __webpack_public_path__ + "files/c158ed6adb20a04de80472df5c7f37f8.svg";